import {GetTypes} from "../../../../helpers/enum-helpers";

export enum LegalType {
  LegalEntity,
  NaturalPerson
}

export const LegalTypeLabels: { [key in LegalType]: string } = {
  [LegalType.LegalEntity]: "Juristische Person",
  [LegalType.NaturalPerson]: "Natürliche Person"
}

export const LegalTypeList: LegalType[] = GetTypes(LegalType).map(x => parseInt(x));
